/* eslint-disable no-unused-vars */
import React, { useEffect } from 'react';

import PropTypes from 'prop-types';

import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import { Button, Form, Modal, Radio, Row, Space, Tooltip } from 'antd';

import CustomRadioButton from '../CustomRadioButton/CustomRadioButton';
import { ReactComponent as Next } from './img/next-icon.svg';
import './style.scss';
import { adviseList } from '../../pages/Onboarding/data/advise-list';

const ModalOnboarding = ({
  userId,
  openStart,
  handleClose,
  onboardingTemplates,
}) => {
  const { t } = useTranslation('');
  const [form] = Form.useForm();
  const history = useHistory();

  useEffect(() => {
    if (adviseList?.length) {
      form.setFieldValue('code', adviseList[0]?.code);
    }
  }, []);

  const getAdvice = (path) => {
    return onboardingTemplates?.[path];
  };

  // const handleCreate = () => {
  //   if(onboardingForms?.length) {
  //     const formId = onboardingForms[0]?.id;
  //     history.push(`/onboarding/edit/new?account-id=${userId}&form-id=${formId}`);
  //   }
  // };
  const onSubmit = (data) => {
    const { code } = data;
    if (code) {
      history.push(
        `/onboarding/edit/new?account-id=${userId}&code=${code}`,
      );
      handleClose();
    }
  };

  return (
    <Modal
      width={700}
      className="onboarding-start-modal"
      centered
      open={openStart}
      onCancel={handleClose}
      footer={false}
      zIndex={1500}
      closable={false}
      onFinish={onSubmit}
    >
      <div className="">
        <h1 className="onboarding-start-title">{t('ADVICE')}</h1>
        <p className="onboarding-start-description">{t('SELECT_ADVICE')}</p>
        <div className="options-wrapper">
          <h2 className="options-title">{t('OPTIONS')}*</h2>
          <Form
            form={form}
            name="filter-config"
            layout="vertical"
            onFinish={onSubmit}
          >
            <Form.Item name="code" className="">
              <Radio.Group className="options-radio-group">
                <Space direction="vertical">
                  {adviseList?.map((form) => (
                    <CustomRadioButton key={form.code} value={form.code}>
                    <Tooltip
                      placement="top"
                      title={<span style={{ color: '#000000' }}>{getAdvice(form.path)?.description}</span>} color='white'
                    >
                      <span className="onboarding-form-name">{getAdvice(form.path)?.name}</span>
                    </Tooltip>
                    </CustomRadioButton>
                  ))}
                </Space>
              </Radio.Group>
            </Form.Item>
          </Form>
        </div>
      </div>
      <Row justify={'center'} className="onboarding-start-btn-wrapper">
        <Button
          className="onboarding-start-submit"
          icon={<Next />}
          iconPosition="end"
          onClick={() => form.submit()}
        >
          {t('CONTINUE')}
        </Button>
      </Row>
    </Modal>
  );
};

export default ModalOnboarding;

ModalOnboarding.propTypes = {
  userId: PropTypes.string,
  openStart: PropTypes.bool,
  handleClose: PropTypes.func,
  onboardingTemplates: PropTypes.object.isRequired,
};
